<template>
  <div class='EnbCategory'>
    <div class="cont">
      <category-list
      v-for="(l, key) in Categorys"
      :key="key"
      :data="l"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CategoryList from './CategoryList'
export default {
  name: 'EnbCategory',
  components: { CategoryList },
  data () {
    return {
      Categorys: []
    }
  },
  methods: {
    ...mapActions(['GetFrenteLojaCategoria'])
  },
  created () {
    this.GetFrenteLojaCategoria()
      .then(res => {
        this.Categorys = res
      })
  }
}
</script>

<style scoped>
.EnbCategory {
  width: 100%;
  /* height: 100%; */
}

.text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: bold;
  width: 96%;
  padding: 2%;
}

.cont {
  width: 70%;
  /* height: 95%; */
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}

@media (max-width: 500px) {
  .cont {
    width: 100%;
  }
  
  .text {
    width: 90%;
    padding: 5%;
  }
}
</style>
